import { render } from "./ResidualOilComposition.vue?vue&type=template&id=52b6b0fe"
import script from "./ResidualOilComposition.vue?vue&type=script&lang=js"
export * from "./ResidualOilComposition.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__